import { defineMessages } from 'react-intl';

export default defineMessages({
    continueText: {
        id: 'ml.quoteandbind.ho.additionalInfoToQuote.We\'ll review your quote next',
        defaultMessage: 'We\'ll review your {quote} next'
    },
    quote: {
        id: 'ml.quoteandbind.ho.additionalInfoToQuote.quote',
        defaultMessage: 'quote'
    },
    addClaimTitle: {
        id: 'ml.quoteandbind.ho.additionalInfoToQuote.If there have been any additional claims for this property in the past 5 years, please add them here.',
        defaultMessage: 'If there have been any additional claims for this property in the past 5 years, please add them here.'
    },
    addClaim: {
        id: 'ml.quoteandbind.ho.additionalInfoToQuote.Add Claim',
        defaultMessage: 'Add Claim'
    },
    prefillDisclosureMessage: {
        id: 'ml.quoteandbind.ho.additionalInfoToQuote.We found this information about your claims',
        defaultMessage: 'We found this information about your claims'
    },
    manualDisclosureMessage: {
        id: 'ml.quoteandbind.ho.additionalInfoToQuote.You entered this information regarding claims for you',
        defaultMessage: 'You entered this information regarding claims for you'
    },
    date: {
        id: 'ml.quoteandbind.ho.additionalInfoToQuote.DATE',
        defaultMessage: 'DATE'
    },
    dateMobile: {
        id: 'ml.quoteandbind.ho.additionalInfoToQuote.DATE MOBILE',
        defaultMessage: 'DATE:'
    },
    name: {
        id: 'ml.quoteandbind.ho.additionalInfoToQuote.NAME',
        defaultMessage: 'NAME'
    },
    nameMobile: {
        id: 'ml.quoteandbind.ho.additionalInfoToQuote.NAME MOBILE',
        defaultMessage: 'NAME:'
    },
    description: {
        id: 'ml.quoteandbind.ho.additionalInfoToQuote.DESCRIPTION',
        defaultMessage: 'DESCRIPTION'
    },
    descriptionMobile: {
        id: 'ml.quoteandbind.ho.additionalInfoToQuote.DESCRIPTION MOBILE',
        defaultMessage: 'DESCRIPTION:'
    },
    amountPaid: {
        id: 'ml.quoteandbind.ho.additionalInfoToQuote.AMOUNT PAID',
        defaultMessage: 'AMOUNT PAID'
    },
    amountPaidMobile: {
        id: 'ml.quoteandbind.ho.additionalInfoToQuote.AMOUNT PAID MOBILE',
        defaultMessage: 'AMOUNT PAID:'
    },
    actions: {
        id: 'ml.quoteandbind.ho.additionalInfoToQuote.ACTIONS',
        defaultMessage: 'ACTIONS'
    },
    actionsMobile: {
        id: 'ml.quoteandbind.ho.additionalInfoToQuote.ACTIONS MOBILE',
        defaultMessage: 'ACTIONS:'
    },
    delete: {
        id: 'ml.quoteandbind.ho.additionalInfoToQuote.Delete',
        defaultMessage: 'Delete'
    },
    helptext:{
        id: 'ml.quoteandbind.ho.additionalInfoToQuote.What does this mean',
        defaultMessage: 'What does this mean?'
    },
    helptextMap:{
        id: 'ml.quoteandbind.ho.additionalInfoToQuote.newPolicySameLocation',
        defaultMessage: 'You are purchasing a new policy for the same location but with different type of coverage.  For example, purchasing the home you were previously renting.'
    },
    showDisclosureTooltipLabel: {
        id: 'ml.quoteandbind.ho.additionalInfoToQuote.showDisclosureTooltipLabel',
        defaultMessage: 'What if one of the items shown is not mine?'
    },
    showDisclosureTooltipContent: {
        id: 'ml.quoteandbind.ho.additionalInfoToQuote.showDisclosureTooltipContent',
        defaultMessage: 'If one of the items shown is not for you or your household, please contact us by chat. We will advise you on the proof needed to remove the item.'
    },
       mlUwIssueNormalFlowContentQB1: {
        id: 'ml.quoteandbind.ho.additionalInfoToQuote.Please give us a call at ',
        defaultMessage: 'To complete your quote, please call us at {phoneNum} to talk to one of our licensed specialists. Be sure reference your quote number {quoteID}. '
    },
    mlUwIssueNormalFlowQB2: {
        id: 'ml.quoteandbind.ho.additionalInfoToQuote.We need a little more information',
        defaultMessage: 'Your quote needs to be reviewed by a specialist. '
    }
});
